import { useMutation } from '@tanstack/react-query';
import { signalRConnectionIdKey } from '@legacy/screens/ResourcePlanner/sessionStorageKeys';
import { postFetch } from '@legacy/utils/fetcher';
import { formatUrl } from '@legacy/utils/url';
import { POST_RESOURCE_PLANNER_CHANGE_MSW_STATUS_KEY } from './postResourcePlannerChange.constants';

const POST_RESOURCE_PLANNER_CHANGE_URL_PATH =
  '/api/v2/resource-planner/book-hours';

export interface PostResourcePlannerChangeData {
  resourceId: string | undefined;
  workItemId: string | undefined;
  unitType: string;
  value: string;
  startsAt: string;
  endsAt: string;
}

export const usePostResourcePlannerChange = () => {
  const path = formatUrl(POST_RESOURCE_PLANNER_CHANGE_URL_PATH);
  const hubConnectionId = sessionStorage.getItem(signalRConnectionIdKey);
  const postResourcePlannerChange = ({
    resourceId,
    workItemId,
    unitType,
    value,
    startsAt,
    endsAt,
  }: PostResourcePlannerChangeData) =>
    postFetch({
      path,
      key: POST_RESOURCE_PLANNER_CHANGE_MSW_STATUS_KEY,
      body: JSON.stringify({
        resourceId,
        workItemId,
        unitType,
        value,
        startsAt,
        endsAt,
        hubConnectionId,
      }),
    });

  return useMutation({
    mutationFn: postResourcePlannerChange,
    onMutate: async (variables) => variables,
  });
};
